import React, { useReducer, useState } from "react";
import PropTypes from "prop-types";
import BrandTable from "../../elements/Tables/BrandTable/BrandTable";
import BrandCreationForm from "../../elements/Forms/BrandCreationForm/BrandCreationForm";

import { useFetch } from "../../../Utils/useFetch";

import {
  FETCH_ALL_BRAND_API,
} from "../../../Constants/Apis"
import { Button, Flex, Input, message, Modal } from "antd";
import { reducer } from "../../../Utils/CommonUtils";
import { deleteBrand } from "../../../Services/BrandService";

const { Search } = Input;

const BrandPage = ({ history, userData }) => {
  const initialState = {
    searchKeyword: "",
    filteredInfo: {},
    sorter: {},
  };

  const [state, dispatch] = useReducer(reducer, initialState);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [brandId, setBrandId] = useState(null);

  const handleOpenModal = () => setIsModalVisible(true);
  const handleCloseModal = () => setIsModalVisible(false);

  const handleDelete = async (id) => {
    setBrandId(id);
    setIsModalOpen(true);
  };

  const handleOk = async () => {
    try {
      await deleteBrand(brandId);
      message.success("Brand deleted successfully");
      callReFetch();
    } catch (error) {
      message.error(
        error?.response?.data?.message ||
          "Something went wrong, failed to delete brand."
      );
    }
    setIsModalOpen(false);
  };

  const {
    fetchedData: { data },
    callReFetch,
    loading,
  } = useFetch(`${FETCH_ALL_BRAND_API}`, state);

  const handleSearch = (value) => {
    dispatch({ type: "searchKeyword", payload: value });
    callReFetch();
  };

  return (
    <div
      style={{
        width: "100vw",
        padding: "20px",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <div
        style={{
          paddingBottom: "20px",
          display: "flex",
          justifyContent: "space-between",
          width: "50vw",
          maxWidth: "100vw",
        }}
      >
        <Button type="primary" onClick={handleOpenModal}>
          Create New Brand
        </Button>
        <Search
          placeholder="Search..."
          allowClear
          onSearch={handleSearch}
          style={{ width: "300px" }}
        />
      </div>

      <BrandTable
        history={history}
        loading={loading}
        userData={userData}
        data={data}
        callReFetch={callReFetch}
        dispatch={dispatch}
        handleDelete={handleDelete}
      />

      <Modal
        title="Create Brand"
        open={isModalVisible}
        footer={null}
        onCancel={handleCloseModal}
      >
        <BrandCreationForm
          history={history}
          userData={userData}
          callReFetch={callReFetch}
          onClose={handleCloseModal}
        />
      </Modal>

      <Modal
        title="Delete Brand"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={() => setIsModalOpen(false)}
      >
        <p>Are you sure you want to delete this brand?</p>
      </Modal>
    </div>
  );
};

BrandPage.propTypes = {};

export default BrandPage;
